export default "__VITE_ASSET__Fx3Hlohf__"